import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form } from 'redux-form';

import { FormError } from 'common/components/layout';
import {
  convertDateStringToISODate,
  dateFormatNoTimeZone
} from 'common/helpers/dateHelper';
import { convertStringToInteger } from 'common/helpers/numberHelper';
import { listReservationTypes } from 'redux/reservationTypes/actions';

import Experiences from './components/Experiences';
import GuestCount from './components/GuestCount';
import ReservationDate from './components/ReservationDate';
import ReservationTime from './components/ReservationTime';
import { validateSearch } from './validators';

class SearchForm extends Component {
  componentDidMount() {
    const { props } = this;
    props.listReservationTypes();
  }

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    props.onSearch(data);
  };

  render() {
    const { reservationType, handleSubmit, form, settings } = this.props;
    if (!reservationType.data) {
      return null;
    }
    return (
      <div className="c7-reservation-widget c7-reservation-widget--search">
        <Form
          onSubmit={handleSubmit(this.handleSubmit)}
          className="c7-form c7-reservation-widget"
        >
          <FormError formName={form} />
          <div>
            <div className="c7-form__group">
              <Experiences reservationTypes={reservationType} />
              <ReservationDate settings={settings} />
              <GuestCount settings={settings} />
              <ReservationTime settings={settings} />
            </div>
          </div>

          <button className="c7-button" type="submit">
            Check Availability
          </button>
        </Form>
      </div>
    );
  }
}

const transformData = (values) => {
  const data = {
    reservationTypeId: values.reservationTypeId,
    guestCount: values.guestCount && convertStringToInteger(values.guestCount),
    reservationTime: values.reservationTime
  };
  try {
    data.reservationDate = convertDateStringToISODate(values.reservationDate);
  } catch {
    data.reservationDate = values.reservationDate;
  }
  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateSearch(data);
  return errors;
};

const mapStateToProps = (state, ownProps) => ({
  reservationType: state.reservationType,
  settings: state.setting,
  initialValues: {
    reservationDate:
      ownProps.reservationDate &&
      dateFormatNoTimeZone(ownProps.reservationDate),
    guestCount: ownProps.guestCount || 2,
    reservationTime: ownProps.reservationTime,
    reservationTypeId: ownProps.reservationTypeId
  }
});

SearchForm = reduxForm({
  form: 'searchForm',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(SearchForm);

export default connect(mapStateToProps, { listReservationTypes })(SearchForm);
